import React from 'react'
import DynamicColor from '../common/dynamic-color'
import IconClose from '../../assets/icons/IconClose'
import WrapIcon from '../elements/WrapIcon'
import { Link } from 'react-router-dom'

import { COLOR_NAME, ORDER_METHOD } from '../../constants'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import paths from '../../routes/paths'

import userImg from '../../assets/images/user.png'
import { ReactComponent as IconHome } from '../../assets/icons/svg/home.svg'
import { ReactComponent as IconLogin } from '../../assets/icons/svg/login.svg'
import { ReactComponent as IconLock } from '../../assets/icons/svg/lock.svg'
import { ReactComponent as IconUser } from '../../assets/icons/svg/user.svg'
import { ReactComponent as IconLogout } from '../../assets/icons/svg/logout.svg'

const Sidebar = ({
    className = '',
    isOpen,
    toggleSidebar,
    toggleAdrMgr,
    user,
    showLogin,
    handleLogout,
}) => {
    const { t } = useTranslation()

    const classes = ['app-sidebar', isOpen ? 'open' : '', className].join(' ')
    const { orderMethod } = useSelector(state => state.OrderReducer)

    const menus = [
        {
            label: t('sidebar.btnHome'),
            Icon: IconHome,
            props: {
                to: paths.listFood,
                tag: Link,
            },
            auth: undefined,
        },
        {
            label: t('sidebar.btnLogin'),
            Icon: IconLogin,
            props: {
                onClick: showLogin,
            },
            auth: false,
            onClick: '',
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
        {
            label: t('sidebar.btnRegister'),
            Icon: IconLock,
            props: {
                to: paths.register,
                tag: Link,
            },
            auth: false,
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
        {
            label: t('sidebar.btnUpdateUserInfo'),
            Icon: IconUser,
            props: {
                to: paths.updateProfile,
                tag: Link,
            },
            auth: true,
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
        {
            label: t('sidebar.btnAddressMgr'),
            Icon: IconUser,
            props: {
                onClick: () => (toggleSidebar(), toggleAdrMgr(true)),
            },
            auth: true,
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
        {
            label: t('sidebar.btnUpdatePassword'),
            Icon: IconLock,
            props: {
                to: paths.updatePassword,
                tag: Link,
            },
            auth: true,
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
        // {
        //     label: 'Kiểm tra đơn hàng',
        //     Icon: IconHome,
        //     props: {
        //         to: paths.orderDetails,
        //         tag: Link,
        //     },
        //     auth: undefined,
        // },
        {
            label: t('sidebar.btnLogout'),
            Icon: IconLogout,
            props: {
                onClick: handleLogout,
            },
            auth: true,
            ignoreOrderMethod: [
                ORDER_METHOD.QR_CODE,
                ORDER_METHOD.TABLE_QRCODE,
            ],
        },
    ]

    const userShow = user || {
        userName: t('sidebar.lbNotLogin'),
    }

    return (
        <div className={classes}>
            <div className="app-sidebar__backdrop" onClick={toggleSidebar} />
            <div className="app-sidebar__content">
                <DynamicColor
                    style={{
                        backgroundColor: COLOR_NAME.SIDEBAR_HEAD_BG,
                        color: COLOR_NAME.SIDEBAR_TEXT,
                    }}
                    className="app-sidebar__user"
                >
                    <div className="d-flex align-items-center flex-1">
                        {/* <img className="avatar" alt="avatar" src={userImg} /> */}
                        <i className="avatar fas fa-2x fa-user-circle" />
                        <div className="ml-4 label-1">{userShow.userName}</div>
                    </div>

                    <WrapIcon
                        icon={IconClose}
                        size="20px"
                        onClick={toggleSidebar}
                        color="ffffff"
                        className="pointer"
                    />
                </DynamicColor>

                <DynamicColor
                    style={{
                        backgroundColor: COLOR_NAME.SIDEBAR_BG,
                        color: COLOR_NAME.SIDEBAR_TEXT,
                    }}
                    className="main-content"
                >
                    <div className="sb-row sb-offset-top">
                        <div className="col-icon"></div>
                        <div className="col-content" />
                    </div>

                    {menus
                        .filter(menu => {
                            const validAuth =
                                menu.auth === undefined || !!user === menu.auth
                            const validOrderMethod =
                                !menu.ignoreOrderMethod ||
                                !menu.ignoreOrderMethod.includes(orderMethod)

                            return validAuth && validOrderMethod
                        })
                        .map(el => (
                            <div key={el.label} className="sb-row">
                                <div className="col-icon">
                                    {/* <DynamicColor
                                        tag="i"
                                        className={el.icon}
                                        style={{
                                            color: COLOR_NAME.SIDEBAR_ICON,
                                        }}
                                    /> */}
                                    <el.Icon
                                        fill="black"
                                        width="20px"
                                        height="20px"
                                    />
                                </div>
                                <DynamicColor
                                    className="col-content label-1"
                                    onClick={toggleSidebar}
                                    {...el.props}
                                >
                                    {t(el.label)}
                                </DynamicColor>
                            </div>
                        ))}

                    <div className="sb-row sb-offset-bottom">
                        <div className="col-icon"></div>
                        <div className="col-content" />
                    </div>
                </DynamicColor>
            </div>
        </div>
    )
}

export default Sidebar
